goog.provide("shadow.js.shim.module$keycloak_js$default");
shadow.js.shim.module$keycloak_js$default = shadow.js.shim.module$keycloak_js.default;
